import SkeletonLoader from './index';

const GameDetailsDrawerSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full">
      {/* Overview Section */}
      <div className="flex flex-col gap-4 w-full">
        <SkeletonLoader width={100} height={22} />

        {/* Game card */}
        <div className="flex flex-col gap-6 rounded-2xl border border-neutral-light-200 p-4">
          {/* Name + stage row */}
          <div className="flex items-center gap-2">
            <SkeletonLoader width={40} height={40} className="rounded-lg" />
            <div className="flex items-center gap-3 flex-1">
              <SkeletonLoader width={140} height={24} />
              <SkeletonLoader width={72} height={24} className="rounded-full" />
            </div>
          </div>

          {/* Stat cards */}
          <div className="grid w-full grid-cols-3 gap-4">
            {[1, 2, 3].map((_, i) => (
              <div
                key={i}
                className="flex flex-col items-center rounded-lg px-4 py-2 gap-1.5"
              >
                <SkeletonLoader width={48} height={14} />
                <SkeletonLoader width={56} height={32} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Activity Timeline Section */}
      <div className="flex flex-col gap-4 w-full">
        <SkeletonLoader width={140} height={22} />

        <div className="flex flex-col">
          {[1, 2, 3, 4, 5].map((_, idx, arr) => {
            const isLast = idx === arr.length - 1;
            return (
              <div key={idx} className="flex items-start gap-4">
                {/* Icon + vertical line */}
                <div className="relative flex flex-col items-center">
                  <div className="z-10 flex h-10 w-10 items-center justify-center">
                    <SkeletonLoader variant="circle" width={24} height={24} />
                  </div>
                  {!isLast && (
                    <div className="absolute top-7 h-[calc(100%+4px)] w-px bg-neutral-light-200" />
                  )}
                </div>

                {/* Content */}
                <div className="flex flex-1 items-center justify-between pb-6">
                  <div className="flex flex-col gap-1">
                    <SkeletonLoader width={100} height={18} />
                    <SkeletonLoader width={60} height={14} />
                  </div>
                  <SkeletonLoader width={40} height={18} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GameDetailsDrawerSkeleton;
